//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
  data() {
    return {
      cities : ["上海","北京","广州","重庆","西安"],
      arr : [],
      datalist:[],
      sun:"",
      discount:0,
      kfc:"",
      lock:1,
      docid:'',
      pay: true,
      inquirypeople:this.$store.state.inquirypeople,
      patientid: this.$store.state.userInfo.id,
      addressTitle:[],


      page:1,             //页码
      pagination:1,//请求数据
      heightof:"-90",
      message: '暂无医生',
      displayshow: false,
      skillData: [],
      noDataText: '',
      total: 0,
      skillname: '',
      doctorname: '',
      type: '',

    }
  },
  // 生命周期之挂载完成
  methods: {
    queryDoctor(){
      this.$refs.inputs.blur();
      if(this.doctorname!=''){
        var searchhistory=JSON.parse(localStorage.getItem("searchhistory"))!=null?JSON.parse(localStorage.getItem("searchhistory")):[];
        searchhistory.unshift(this.doctorname);
        this.searchhistory=Array.from(new Set(searchhistory));
        if(this.searchhistory.length>15){
          this.searchhistory.splice(15,1);
        }
        localStorage.removeItem("searchhistory");
        localStorage.setItem("searchhistory", JSON.stringify(this.searchhistory));
        this.$store.state.doctorSearch=this.doctorname;
        this.$router.push({path:'/doctorList'});
      }
    },
    goDepartment(e){
      this.$store.state.doctorSearch=e;
      this.$router.push({path:'/doctorList'});
    },
  },
  //生命周期之创建完成
  created: function() {
    document.title = '全部科室';
  }
}



// WEBPACK FOOTER //
// ./src/views/department/index.vue